import React, { useEffect, useState } from 'react';
import discordService from '../../services/discordService';
import adminService from '../../services/adminService';

/**
 * Carrega anexo do chat com Authorization (img src puro não envia Bearer).
 */
const SupportAttachmentImage = ({ attachment, role = 'user', className = '' }) => {
  const [src, setSrc] = useState(attachment?.dataUrl || null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!attachment) return undefined;
    if (attachment.dataUrl) {
      setSrc(attachment.dataUrl);
      setFailed(false);
      return undefined;
    }
    if (!attachment.url) {
      setFailed(true);
      return undefined;
    }

    let objectUrl = null;
    let cancelled = false;

    (async () => {
      try {
        const token =
          role === 'staff'
            ? adminService.getAccessToken()
            : discordService.getPlayerAccessToken();
        if (!token) {
          if (!cancelled) setFailed(true);
          return;
        }
        const url =
          role === 'staff'
            ? `${attachment.url}${attachment.url.includes('?') ? '&' : '?'}role=staff`
            : attachment.url;
        const res = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('fail');
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) {
          setSrc(objectUrl);
          setFailed(false);
        }
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [attachment, role]);

  if (failed) {
    return <span className="scw__attach-fail">[imagem indisponível]</span>;
  }
  if (!src) {
    return <span className="scw__attach-loading">Carregando imagem…</span>;
  }

  return (
    <a href={src} target="_blank" rel="noopener noreferrer" className="scw__attach-link">
      <img
        className={className || 'scw__attach-img'}
        src={src}
        alt={attachment?.name || 'Comprovante'}
        loading="lazy"
      />
    </a>
  );
};

export default SupportAttachmentImage;
